/**
 * Format Talent legal name with optional preferred name in brackets (T2-5714).
 *
 * inline (default): "Legal First Last (Preferred)"
 * stacked: "Legal First Last\n(Preferred)" — preferred on the line below
 */
export type TalentDisplayNameLayout = 'inline' | 'stacked';

export function formatTalentDisplayName(
  firstName?: string | null,
  lastName?: string | null,
  preferredName?: string | null,
  options?: { layout?: TalentDisplayNameLayout },
): string {
  const layout = options?.layout || 'inline';
  const legal = [firstName, lastName]
    .map((part) => (part == null ? '' : String(part).trim()))
    .filter(Boolean)
    .join(' ');
  const preferred = preferredName == null ? '' : String(preferredName).trim();

  if (!preferred) {
    return legal;
  }
  if (!legal) {
    return `(${preferred})`;
  }
  if (layout === 'stacked') {
    return `${legal}\n(${preferred})`;
  }
  return `${legal} (${preferred})`;
}
